// extracted by mini-css-extract-plugin
export default {"container":"Mda-z","creativeContainer":"Nda-z","copy":"Oda-z","cta":"Pda-z","disabled":"Qda-z","flipped":"Rda-z","productCard":"Sda-z"};